// extracted by mini-css-extract-plugin
export default {"imageWrapper":"lN-z","twoColumnImage":"mN-z"};